export default "__VITE_ASSET__457c8a77__"